import "../Styles/HeadingPages.scss"

export default function HeadingPages({heading}) {
    return (
            <div className="cars-bg">
                <h1>{heading}</h1>
            </div>
    )
}